import type { NotificationDto } from "@keydials/api-client";

// Upgrade notices a dial admin still has to act on (KEY-807): queued, the reminder, and "choose where some items go". Each opens
// the dial at its update notice, which shows even if "Got it" hid it. "Applied" has no notice left to open.
const UPGRADE_NOTICE_TYPES = new Set(["version-upgrade-queued", "version-upgrade-reminder", "version-upgrade-needs-mapping"]);

/** Where a notification takes you: its dial, and on an upgrade notification that dial's update notice. */
export function notificationHref(n: Pick<NotificationDto, "dialInstanceId" | "type">): string {
  return `/instances/${n.dialInstanceId}${UPGRADE_NOTICE_TYPES.has(n.type) ? "#upgrade" : ""}`;
}
